<app-dialog [header]="data.header" cancelBtnLabel="Close">
  <div slot="content">
    <h4>{{data.title}}</h4>
    <p>{{data.message}}</p>
  </div>
</app-dialog>
